import { useEffect, useRef } from "react";
import gsap from "gsap";

export default function LogoIntro({ onComplete }) {
  const containerRef = useRef(null);
  const logoRef = useRef(null);
  const linesRef = useRef([]);

  useEffect(() => {
    const tl = gsap.timeline({
      onComplete: () => {
        gsap.to(containerRef.current, {
          opacity: 0,
          duration: 0.5,
          onComplete
        });
      }
    });

    linesRef.current.forEach((line, i) => {
      if (line) {
        gsap.set(line, { x: -300 - i * 80, opacity: 0 });
        tl.to(line, {
          x: window.innerWidth + 300,
          opacity: 1,
          duration: 0.5,
          ease: "power2.in"
        }, i * 0.06);
      }
    });

    gsap.set(logoRef.current, { scale: 0.5, opacity: 0, rotateY: -30 });
    tl.to(logoRef.current, {
      scale: 1,
      opacity: 1,
      rotateY: 0,
      duration: 0.7,
      ease: "back.out(1.7)"
    }, 0.4);

    tl.to(logoRef.current, {
      textShadow: "0 0 80px rgba(232, 149, 42, 1), 0 0 160px rgba(232, 149, 42, 0.6)",
      duration: 0.5,
      yoyo: true,
      repeat: 1
    }, "-=0.3");

    tl.to({}, { duration: 0.6 });

    return () => tl.kill();
  }, [onComplete]);

  const handleSkip = () => {
    onComplete();
  };

  return (
    <div ref={containerRef} className="logo-intro" data-testid="logo-intro" role="status" aria-label="UNDRIVE wird geladen">
      <div className="intro-particles" aria-hidden="true">
        {[...Array(50)].map((_, i) => (
          <div key={`p-${i}`} className="intro-particle" style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 2}s`,
            animationDuration: `${2 + Math.random() * 3}s`
          }} />
        ))}
      </div>
      {[...Array(10)].map((_, i) => (
        <div
          key={i}
          ref={el => linesRef.current[i] = el}
          className="speed-line"
          style={{ top: `${10 + i * 8}%` }}
          aria-hidden="true"
        />
      ))}
      <div ref={logoRef} className="intro-logo" aria-hidden="true">
        <span className="intro-un">UN</span>DRIVE<sup className="intro-triangle-wrap"><svg className="intro-triangle" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0L28 0L28 28Z" fill="#E8952A"/></svg></sup><sup className="trademark">®</sup>
      </div>
      <button
        className="skip-intro-btn"
        onClick={handleSkip}
        data-testid="skip-intro-btn"
        aria-label="Animation überspringen"
      >
        Überspringen
      </button>
    </div>
  );
}
